export default __webpack_public_path__ + "static/media/background.bef2d3bc.jpg";